import FacilityList from './FacilityList'

export default FacilityList;